import React, { FC } from 'react'
import classNames from 'classnames'
import format from 'date-fns/format'
import styles from 'styles/components/card.module.scss'
import { Spacer } from 'components/Utility'
import text from 'styles/utility/text.module.scss'
import { FlexRow } from 'components/Flex'
import { OrderType } from 'types/checkout'
import { Checkbox } from 'components/Form'
import { Caution } from 'components/Typography'
import { parseToDate } from 'lib/helper'

type Props = {
  scheduledDeliveryDate: string
  scheduledDeliveryTime: string
  shippingNumber: string
  order: OrderType
  orderTimes: number
  tel: string
  username: string
}

const PrintDeliveryOrderHeader: FC<Props> = (props) => {
  const { scheduledDeliveryDate, scheduledDeliveryTime, shippingNumber, order, orderTimes, tel, username } = props

  return (
    <div>
      {order.status === 'canceled' && (
        <>
          <FlexRow justifyContent={'center'}>
            <Caution caution={'この注文はキャンセルされています'} size={'large'} />
          </FlexRow>
        </>
      )}
      <FlexRow justifyContent={'between'}>
        <FlexRow justifyContent={'start'}>
          <span className={styles.printOrder__header__label}>受け渡し番号 ： </span>
          <Spacer size={4} />
          <h2 className={styles.printOrder__header__number}>{shippingNumber}</h2>
        </FlexRow>
        <Spacer size={8} />
        <FlexRow justifyContent={'end'}>
          <span className={styles.printOrder__header__username}>
            {username}様({orderTimes}回目)
          </span>
          <Spacer size={24} />
          <span className={styles.printOrder__header__tel}>{tel}</span>
        </FlexRow>
      </FlexRow>
      <Spacer size={4} />
      <FlexRow justifyContent={'between'}>
        <FlexRow justifyContent={'start'}>
          <span className={classNames(text.font_mediumLarge, text.font_bold)}>お届け希望日時 :</span>
          <Spacer size={4} />
          <span className={classNames(text.font_xlarge, text.font_bold, text.color_orange_main)}>
            {format(parseToDate(scheduledDeliveryDate), 'yyyy年M月d日')} {scheduledDeliveryTime}
          </span>
        </FlexRow>
        <FlexRow justifyContent={'end'}>
          <Checkbox
            disabled={true}
            fontSize={14}
            id={order.checkout_id ?? ''}
            isChecked={order.is_prepared}
            label={'準備済'}
          />
          <Spacer size={8} />
          <Checkbox
            disabled={true}
            fontSize={14}
            id={order.checkout_id ?? ''}
            isChecked={order.is_delivered}
            label={'受渡済'}
          />
        </FlexRow>
      </FlexRow>
    </div>
  )
}

export default PrintDeliveryOrderHeader
